import styled from 'styled-components'
import {CloseCircleTwoTone} from '@ant-design/icons'

export const Style = styled.div`
  display: flex;
  align-items: center;
  color: white;
  font-size: 1.25rem; /* Increased from 1rem */
  margin-left: 1rem;

  h1.ant-typography {
    color: white;
  }

  .anticon {
    margin-left: 0.5rem;
    font-size: 1.25rem; /* Ensure icon sizes match text */
  }
`

export const CancelButton = styled(CloseCircleTwoTone)`
  color: gray;
  font-size: 0.5rem;
`
